import { render, staticRenderFns } from "./LinkData.vue?vue&type=template&id=01bf8c66&scoped=true&"
import script from "./LinkData.vue?vue&type=script&lang=js&"
export * from "./LinkData.vue?vue&type=script&lang=js&"
import style0 from "./LinkData.vue?vue&type=style&index=0&id=01bf8c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf8c66",
  null
  
)

export default component.exports